module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921075651_T.050584d3.jpg";